import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { brl, fmtDate, statusLabel, statusColor } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Quotes() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("todos");

  useEffect(() => {
    api.get("/quotes").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = filter === "todos" ? items : items.filter((q) => q.status === filter);

  return (
    <div className="space-y-5 animate-in-up" data-testid="quotes-page">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Orçamentos</h1>
          <p className="text-sm text-slate-500">{items.length} no total</p>
        </div>
        <Link to="/app/calculadora">
          <Button className="h-12 bg-sky-600 hover:bg-sky-700 text-white" data-testid="new-quote-btn">
            <Plus className="h-4 w-4 mr-2" /> Novo orçamento
          </Button>
        </Link>
      </div>

      <Tabs value={filter} onValueChange={setFilter}>
        <TabsList className="w-full justify-start overflow-x-auto">
          <TabsTrigger value="todos" data-testid="filter-todos">Todos</TabsTrigger>
          <TabsTrigger value="rascunho" data-testid="filter-rascunho">Rascunhos</TabsTrigger>
          <TabsTrigger value="enviado" data-testid="filter-enviado">Enviados</TabsTrigger>
          <TabsTrigger value="aprovado" data-testid="filter-aprovado">Aprovados</TabsTrigger>
          <TabsTrigger value="recusado" data-testid="filter-recusado">Recusados</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="grid gap-3">
        {filtered.length === 0 && (
          <Card className="border-slate-200"><CardContent className="p-8 text-center text-slate-500 text-sm">
            Nenhum orçamento aqui. Crie o primeiro na calculadora!
          </CardContent></Card>
        )}
        {filtered.map((q) => (
          <Link key={q.id} to={`/app/orcamentos/${q.id}`}>
            <Card className="border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-testid={`quote-card-${q.number}`}>
              <CardContent className="p-4 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-semibold">{q.number} · {q.customer_name}</p>
                  <p className="text-sm text-slate-500 truncate">{q.service_type} · {fmtDate(q.created_at)}</p>
                </div>
                <div className="text-right shrink-0">
                  <p className="font-mono-num font-semibold">{brl(q.calc?.preco_final)}</p>
                  <Badge variant="outline" className={`text-[10px] ${statusColor[q.status]}`}>{statusLabel[q.status]}</Badge>
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
